import { useMemo } from "react";
import useCustomerDetails from "../data/useCustomerDetails";

export const useFeatureFlag = (flagName: string) => {
  const { features } = useCustomerDetails();

  return useMemo(
    () => !!features.data?.data?.some((feature) => feature.name === flagName),
    [features.data, flagName]
  );
};

export const CheckFeatureFlag = useFeatureFlag;
